import React, { useState } from "react";
import axios from "axios";

const Form = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [showAlert, setShowAlert] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Replace with your API endpoint
    const apiEndpoint =
      "https://api.dremerz.net/api/DZ_8925_KalanjiyamEcom_ContactUs_GetInTouchForm_AllData";

    axios
      .post(apiEndpoint, {
        ...formData,
        timestamp: new Date().toLocaleString(),
      })
      .then((response) => {
        console.log("Message sent successfully:", response.data);
        setFormData({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 3000);
      })
      .catch((error) => {
        console.error("Error sending message:", error);
        alert("Failed to send message.");
      });
  };

  return (
    <div className="container form-container py-5 bg-light">
      <h2 className="form-title text-center mb-4">Get In Touch</h2>
      <form className="form-wrapper" onSubmit={handleSubmit}>
        <div className="form-row row mb-3">
          <div className="form-col col-md-6 mb-2">
            <input
              type="text"
              name="name"
              className="form-input form-control"
              placeholder="Name *"
              value={formData.name}
              onChange={handleChange}
              required
              style={{ border: "light" }}
            />
          </div>
          <div className="form-col col-md-6">
            <input
              type="email"
              name="email"
              className="form-input form-control"
              placeholder="Email *"
              value={formData.email}
              onChange={handleChange}
              required
              style={{ border: "light" }}
            />
          </div>
        </div>
        <div className="form-group mb-4">
          <input
            type="text"
            name="subject"
            className="form-input form-control"
            placeholder="Subject *"
            value={formData.subject}
            onChange={handleChange}
            required
            style={{ border: "light" }}
          />
        </div>
        <div className="form-group mb-3">
          <textarea
            name="message"
            className="form-textarea form-control"
            rows="4"
            placeholder="Message"
            value={formData.message}
            onChange={handleChange}
            required
            style={{ border: "light" }}
          ></textarea>
        </div>
        <div className="form-button text-center">
          <button
            type="submit"
            className="form-submit-btn btn"
            style={{ backgroundColor: "#920504", color: "white" }}
          >
            Send message
          </button>
        </div>
      </form>
      <div className="alertbox">
        {showAlert && (
          <div
            className="modal show"
            style={{
              display: "block",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" style={{ color: "#920504" }}>
                    Dear User
                  </h5>
                  {/* <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => setShowAlert(false)}
                  ></button> */}
                </div>
                <div className="modal-body">
                  <p style={{ color: "#920504" }}>Message sent successfully</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Form;
